import { Box, Button, Modal, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import download from "../../assets/images/download.svg";
import { useDispatch } from "react-redux";
import { setToastNotification } from "../ToastNotification/service/toastNotificationSlice";
import styles from "./CommonPopups.module.css";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 408,
    xl: 408,
    md: 408,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: 3,
};

function ViewImagePopup(props: any) {
  const { onClose, image, type } = props;
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const downloadImage = async (url: string) => {
    try {
      setIsDownloading(true);
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "image.png";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed", error);
      dispatch(setToastNotification({
        message: "Download failed",
        type: "error"
      }));
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div>
      <Button
        variant={"outlined"}
        sx={{
          textTransform: "capitalize",
          fontSize: "12px",
          fontWeight: "400",
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        View
      </Button>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "99999999" }}
      >
        <Box sx={style}>
          <div>
            <div className={styles.closeModalButton} >
              {/* <img 
                src={download}
                color="black"
                onClick={() => downloadImage(image)}
              /> */}
              <DownloadIcon
                onClick={() => downloadImage(image)}
              />
              <CloseIcon
                onClick={() => {
                  setOpen(false);
                }}
              />
            </div>
            {image && (
              <div
                className={styles.modalViewImage}
                style={{ borderRadius: type !== "image" ? "50%" : "0%" }}
              >
                <img src={image} alt="img" />
              </div>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default ViewImagePopup;
